import { yodaInfoConstants } from "../constants";
import { yodaInfoService } from "../services";

export const yodaInfoActions = {
  getCookie,
  getPrivacy,
  getSizeScale,
};

function getCookie() {
  return (dispatch) => {
    dispatch(request());

    yodaInfoService.getCookie().then(
      (response) => {
        if (response) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaInfoConstants.GETCOOKIE_ALL_REQUEST };
  }
  function success(cookie) {
    return {
      type: yodaInfoConstants.GETCOOKIE_ALL_SUCCESS,
      payload: { cookie },
    };
  }
  function failure(error) {
    return {
      type: yodaInfoConstants.GETCOOKIE_ALL_FAILURE,
      payload: { error },
    };
  }
}

function getSizeScale() {
  return (dispatch) => {
    dispatch(request());

    yodaInfoService.getSizeScale().then(
      (response) => {
        if (response) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaInfoConstants.GETSCALESIZE_ALL_REQUEST };
  }
  function success(sizeScale) {
    return {
      type: yodaInfoConstants.GETSCALESIZE_ALL_SUCCESS,
      payload: { sizeScale },
    };
  }
  function failure(error) {
    return {
      type: yodaInfoConstants.GETSCALESIZE_ALL_FAILURE,
      payload: { error },
    };
  }
}

function getPrivacy() {
  return (dispatch) => {
    dispatch(request());

    yodaInfoService.getPrivacy().then(
      (response) => {
        if (response) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaInfoConstants.GETPRIVACY_ALL_REQUEST };
  }
  function success(privacy) {
    return {
      type: yodaInfoConstants.GETPRIVACY_ALL_SUCCESS,
      payload: { privacy },
    };
  }
  function failure(error) {
    return {
      type: yodaInfoConstants.GETPRIVACY_ALL_FAILURE,
      payload: { error },
    };
  }
}
